import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'

const ColumnDescription = ({ object, height }) => (
  <Box
    component={'div'}
    height={height}
    overflow={'auto'}
    className={'u-pv-medium '}
    display="flex"
    justifyContent={'center'}
    alignItems="center"
  >
    <Typography style={{ whiteSpace: 'pre-wrap' }} variant="body1">
      {object.description}
    </Typography>
  </Box>
)

ColumnDescription.propTypes = {
  object: PropTypes.object.isRequired,
  height: PropTypes.number,
}

export default ColumnDescription
